import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

import styled from 'styled-components'

import ReactSelect, { components } from 'react-select'

const Option = props => {
    const dataProp = {
        innerProps: {
            'data-testid': props.data.value,
            ...props.innerProps,
        },
    }
    return <components.Option {...{ ...props, ...dataProp }} />
}

const SelectWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .list__menu {
        z-index: 100;
    }
`

const Select = ({
    label = '',
    defaultValue = { label: 'Please Select', value: '' },
    testId,
    testIdItems,
    testIdIndex,
    options,
    ...props
}) => {
    useEffect(() => {
        if (testId !== undefined) {
            const temp = document.getElementsByClassName('list__single-value')

            if (temp.length > 0) {
                for (let index = 0; index < temp.length; index++) {
                    const t1 = temp[index]

                    if (testIdIndex >= 0) {
                        if (index === testIdIndex) {
                            let t2 = document.createAttribute('data-testid')
                            t2.value = testIdItems
                            t1.setAttributeNode(t2)
                        }
                    }

                    if (!testIdIndex) {
                        let t2 = document.createAttribute('data-testid')
                        t2.value = testIdItems
                        t1.setAttributeNode(t2)
                    }
                }
            } else {
                const t1 = temp[0]
                let t2 = document.createAttribute('data-testid')
                t2.value = testIdItems
                t1.setAttributeNode(t2)
            }
        }
    }, [testId, testIdIndex, testIdItems])

    return (
        <SelectWrapper data-testid={testId} {...props}>
            {label && <label className="!mb-1">{label}</label>}

            <ReactSelect
                components={{ Option }}
                className="!w-full"
                classNamePrefix="list"
                isDisabled={props.disabled}
                defaultValue={defaultValue}
                placeholder={props.placeholder || 'Please Select...'}
                options={options}
                {...props}
            />
        </SelectWrapper>
    )
}

Select.displayName = 'Select'

Select.propTypes = {
    label: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
}

export default Select
